import React, { useState } from "react";
import itemImg from "../../../assets/itemImg.png";
import solanaIconRed from "../../../assets/solanaIconRed.svg";
import shareIcon from "../../../assets/shareIcon.svg";
import Details from "../../../components/_item_details/Details/Details";
import History from "../../../components/_item_details/History/History";
import Owner from "../../../components/_item_details/Owner/Owner";
import Tab from "../../../components/_item_details/Tab/Tab";
import styles from "./Main.module.scss";

const Main = ({ setIsModalOpen, setIsModalOpen3 }) => {
  const [stage, setStage] = useState(0);
  return (
    <main className={styles.container}>
      <div className={styles.leftContainer}>
        <img src={itemImg} alt="item" />
      </div>
      <div className={styles.rightContainer}>
        <Tab stage={stage} setStage={setStage} />

        {stage === 0 ? <Owner /> : stage === 1 ? <Details /> : <History />}

        <div className={styles.btnContainer}>
          <button onClick={() => setIsModalOpen(true)}>
            <img src={solanaIconRed} alt="solana" /> Buy for 0.56 SOL
          </button>
          <button onClick={() => setIsModalOpen3(true)}>
            <img src={shareIcon} alt="share" /> Share
          </button>
        </div>
      </div>
    </main>
  );
};

export default Main;
